// Auto-generated by cli/scripts/generate-schema-version.js
export const CORE_VERSION = "1.12.2";
export const SCHEMA_VERSION = "1.12.2";
